import { render, staticRenderFns } from "./BibleCloudBookSelector.vue?vue&type=template&id=a0e9fae4&scoped=true&"
import script from "./BibleCloudBookSelector.vue?vue&type=script&lang=js&"
export * from "./BibleCloudBookSelector.vue?vue&type=script&lang=js&"
import style0 from "./BibleCloudBookSelector.vue?vue&type=style&index=0&id=a0e9fae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e9fae4",
  null
  
)

export default component.exports